import React, { useState, useContext, useEffect } from "react";
import "./TabsHolder.css";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import { GoProjectSymlink } from "react-icons/go";
import { GeneralContext } from "../../../../GeneralProvider";
import AddProjectModal from "./Views/AddProjectModal";

export default function TabsHolder({
  tabs,
  selectedTab,
  handleTabClick,
  closeTab,
  triggerModal,
  onAddNewTab,
}) {
  const { handleAddNewProject } = useContext(GeneralContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleAddProject = async (title, description) => {
    try {
      const newProject = await handleAddNewProject(title, description);
      if (newProject) {
        const { projectId, title } = newProject;
        onAddNewTab({ projectTitle: title, projectID: projectId }); // Yeni tabı eklemek için çağrı
      }
    } catch (error) {
      console.error("Error while adding project:", error);
    }
  };

  useEffect(() => {
    if (triggerModal) {
      openModal();
    }
  }, [triggerModal]);

  return (
    <>
      <nav>
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`tab ${selectedTab === index ? "selected-tab" : ""}`}
            onClick={() => handleTabClick(index)}
            onMouseDown={(e) => {
              if (e.button === 1) {
                e.preventDefault();
                closeTab(index);
              }
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "5px",
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
              }}
            >
              <GoProjectSymlink style={{ minWidth: '20px', width: '20px' }} size={20} />
              <span>{tab.projectTitle}</span>
            </div>
            <AiOutlineClose
              className="close-icon"
              onClick={(e) => {
                e.stopPropagation();
                closeTab(index);
              }}
            />
          </div>
        ))}
        <div onClick={openModal} className="add-tab">
          <AiOutlinePlus size={18} />
        </div>
      </nav>
      <AddProjectModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onCreate={handleAddProject}
        isWorkspace={true}
      />
    </>
  );
}
